import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=06488a8c&scoped=true&"
import script from "./Overview.vue?vue&type=script&lang=js&"
export * from "./Overview.vue?vue&type=script&lang=js&"
import style0 from "./Overview.vue?vue&type=style&index=0&id=06488a8c&prod&lang=scss&"
import style1 from "./Overview.vue?vue&type=style&index=1&id=06488a8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06488a8c",
  null
  
)

export default component.exports